import React from 'react';
import Spinner from '../Spinners/Spinner';

/** Muestra la carga del contenido sin desmontar el layout persistente. */
const LoadingOverlay: React.FC = () => (
  <div className="flex min-h-[50vh] w-full items-center justify-center">
    <Spinner size={60} color="#3C50E0" speedClass="animate-spin" />
  </div>
);

export default LoadingOverlay;
